<ng-container
    [formGroup]="form"
>
    <div class="vstack gap-2">
        <div class="hstack gap-2 align-items-center">
            @if (formNameTitle) {
                <label
                    class="mb-0 form-label fw-semibold"
                >
                    {{ formNameTitle }}
                </label>
            }
            <div class="hstack gap-1 ms-auto">
                <button
                    class="btn btn-close"
                    [disabled]="!canClearDetails"
                    (click)="clearSelected()"
                    type="button"
                >
                </button>
            </div>
        </div>
        <div class="vstack gap-3">
            <div class="">
                <div class="row gap-3 gap-lg-0">
                    <div class="col-lg-6">
                        <div class="position-relative">
                            <input
                                [formControlName]="'firstName'"
                                type="text"
                                class="form-control"
                                id="firstName"
                                [class.is-invalid]="form.get('firstName')?.invalid && form.get('firstName')?.touched"
                                [attr.aria-invalid]="form.get('firstName')?.invalid && form.get('firstName')?.touched"
                                [placeholder]="placeholders.firstName"
                                autocomplete="off"
                                autocapitalize="words"
                                appCapitaliseOnBlur
                                (focusin)="focusInFirstName()"
                                (focusout)="focusOutFirstName()"
                            >
                            <ng-container *ngIf="focusedInput === 'firstName'">
                                <ng-container
                                    [ngTemplateOutlet]="contactSuggestions"
                                    [ngTemplateOutletContext]="{ alignment: 'start-0' }"
                                >
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="position-relative">
                            <input
                                [formControlName]="'lastName'"
                                type="text"
                                class="form-control"
                                id="lastName"
                                [class.is-invalid]="form.get('lastName')?.invalid && form.get('lastName')?.touched"
                                [attr.aria-invalid]="form.get('lastName')?.invalid && form.get('lastName')?.touched"
                                [placeholder]="placeholders.lastName"
                                autocomplete="off"
                                autocapitalize="words"
                                appCapitaliseOnBlur
                                (focusin)="focusInLastName()"
                                (focusout)="focusOutLastName()"
                            >
                            <ng-container *ngIf="focusedInput === 'lastName'">
                                <ng-container
                                    [ngTemplateOutlet]="contactSuggestions"
                                    [ngTemplateOutletContext]="{ alignment: 'end-0' }"
                                >
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            @if (formContactDetailsTitle) {
                <label
                    class="mt-1 mb-0 form-label fw-semibold"
                >
                    {{ formContactDetailsTitle }}
                    @let emailAddressControl = form.get('emailAddress');
                    @let phoneNumberControl = form.get('phoneNumber');
                    @let emailAddressInvalid = emailAddressControl?.invalid && emailAddressControl?.touched;
                    @let phoneNumberInvalid = phoneNumberControl?.invalid && phoneNumberControl?.touched;
                    @if (emailAddressInvalid || phoneNumberInvalid) {
                        <span class="text-danger">
                            (Required)
                        </span>
                    }
                </label>
            }
            <div class="row gap-3 gap-lg-0">
                <div class="col-lg-6">
                    <div class="position-relative">
                        <input
                            [formControlName]="'emailAddress'"
                            type="text"
                            class="form-control"
                            data-testid="email-address"
                            id="emailAddress"
                            [class.is-invalid]="form.get('emailAddress')?.invalid && form.get('emailAddress')?.touched"
                            [attr.aria-invalid]="form.get('emailAddress')?.invalid && form.get('emailAddress')?.touched"
                            [placeholder]="placeholders.emailAddress"
                            autocomplete="off"
                            (focusin)="focusInEmailAddress()"
                            (focusout)="focusOutEmailAddress()"
                        >
                        <ng-container *ngIf="focusedInput === 'emailAddress'">
                            <ng-container
                                [ngTemplateOutlet]="contactSuggestions"
                                [ngTemplateOutletContext]="{ alignment: 'start-0' }"
                            >
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="position-relative">
                        <input
                            [formControlName]="'phoneNumber'"
                            type="text"
                            class="form-control"
                            data-testid="phone-number"
                            id="phoneNumber"
                            [class.is-invalid]="form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched"
                            [attr.aria-invalid]="form.get('phoneNumber')?.invalid && form.get('phoneNumber')?.touched"
                            [placeholder]="placeholders.phoneNumber"
                            autocomplete="off"
                            (focusin)="focusInPhoneNumber()"
                            (focusout)="focusOutPhoneNumber()"
                        >
                        <ng-container *ngIf="focusedInput === 'phoneNumber'">
                            <ng-template
                                [ngTemplateOutlet]="contactSuggestions"
                                [ngTemplateOutletContext]="{ alignment: 'end-0' }"
                            >
                            </ng-template>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        @if (selectedCustomer) {
            <div class="hstack gap-2">
                <img
                    ngSrc="assets/person/normal.svg"
                    alt="Customer Note"
                    width="14"
                    height="14"
                />
                @if (selectedCustomer?.vip) {
                    <img
                        ngSrc="assets/vip/normal_dark.svg"
                        alt="VIP Customer"
                        width="16"
                        height="16"
                        [ngbTooltip]="'VIP Customer'"
                        placement="bottom"
                    />
                }
                @if (selectedCustomer?.note(); as selectedCustomerNote) {
                    <div class="hstack gap-2 py-1 align-items-center flex-grow-1" style="min-width: 0;">
                        @let limit = 60;
                        <span
                            class="text-body-secondary fw-semibold text-truncate"
                            [ngbTooltip]="selectedCustomerNote"
                            [disableTooltip]="selectedCustomerNote.length <= limit"
                            [placement]="'bottom'"
                            [container]="'body'"
                        >
                            {{ selectedCustomerNote }}
                        </span>
                    </div>
                }
                @if (canClickCustomerDetails) {
                    <button
                        class="ms-auto btn btn-sm btn-outline-secondary hstack gap-1 text-nowrap"
                        (click)="customerDetailsClicked(selectedCustomer)"
                        type="button"
                    >
                        Edit Customer
                        <img
                            ngSrc="assets/right/normal.svg"
                            alt="Edit Customer"
                            width="14"
                            height="14"
                        />
                    </button>
                }
            </div>
        }
    </div>
</ng-container>

<ng-template
    #contactSuggestions
    let-alignment="alignment"
>
    <div
        *ngIf="showCustomerSuggestions && customerSearch.length > 0"
        class="position-absolute position-relative bg-body shadow-lg border border-1 border-light rounded-3 z-2"
        [ngClass]="alignment"
        style="max-height: 350px; min-width: 260px; max-width: 400px; overflow-y: auto;"
    >
        <div class="hstack gap-3 justify-content-between position-sticky top-0 bg-body px-3 py-2 z-2 border-bottom">
            <h6
                class="list-group-item list-group-item-action fw-semibold m-0"
            >
                Suggestions
            </h6>
            <button
                class="btn-close"
                (click)="hideCustomerSuggestions()"
                role="button"
            >
            </button>
        </div>
        <ul class="list-group m-0 p-0">
            <ng-container *ngFor="let item of customerSearch">
                <ng-container
                    *ngTemplateOutlet="suggestionTemplate; context: { $implicit: item }"
                ></ng-container>
            </ng-container>
        </ul>
    </div>
</ng-template>

<ng-template
    #suggestionTemplate
    let-item
>
    <li
        class="list-group-item list-group-item-action rounded-0"
        (click)="customerSuggestionSelected(item)"
        role="button"
    >
        <div class="hstack gap-2">
            <div
                class="vstack gap-1"
            >
                <div class="hstack gap-1 fw-semibold">
                    {{ item.firstName }}
                    <span *ngIf="item.lastName">
                        {{ item.lastName }}
                    </span>
                    @if (item.vip) {
                        <img
                            ngSrc="assets/vip/normal_dark.svg"
                            alt="VIP Customer"
                            width="14"
                            height="14"
                        />
                    }
                    @if (item.note()) {
                        <img
                            ngSrc="assets/message/normal_dark.svg"
                            alt="Customer Note"
                            width="14"
                            height="14"
                        />
                    }
                </div>
                <div class="vstack gap-0">
                    @if (item.emailAddress || item.phoneNumber) {
                        @if (item.emailAddress) {
                            <div
                                class="hstack gap-1 align-items-center"
                            >
                                <img
                                    ngSrc="../../../../../assets/email/normal_dark.svg"
                                    alt="Email Address"
                                    width="14"
                                    height="14"
                                >
                                    <span class="text-truncate">
                                        {{ item.emailAddress }}
                                    </span>
                            </div>
                        }
                        @if (item.phoneNumber) {
                            <div
                                class="hstack gap-1 align-items-center"
                            >
                                <img
                                    ngSrc="../../../../../assets/phone/normal_dark.svg"
                                    alt="Phone Number"
                                    width="14"
                                    height="14"
                                >
                                    <span class="text-truncate">
                                        {{ item.phoneNumber | phoneNumber }}
                                    </span>
                            </div>
                        }
                    } @else {
                        <span class="text-truncate">
                            No Contact Details
                        </span>
                    }
                </div>
            </div>
        </div>
    </li>
</ng-template>
